// Shell component to collect attributes for root DOM element
export default function InputPropsCollector() {
  return null;
}

InputPropsCollector.displayName = "Input.Container";
